<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyAreaUnitListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyAreaUnitListing from "@/views/pages/admin/propertyAreaUnit/propertyAreaUnitListing";

export default {
    page: {
        title: i18n.t("module.propertyAreaUnit"),
    },
    components: { Layout, PageHeader, PropertyAreaUnitListing },
    data() {
        return {
            title: i18n.t("module.propertyAreaUnit"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyAreaUnit"),
                    active: true,
                },
            ],
        };
    },
}
</script>
